import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Form } from 'antd';
import PropTypes from "prop-types";
import { InputField } from "../../../../../../../CommonComponents/commonStyles";
import { ErrorMesage } from "../../ContributionType/styles";
import { WrapLabel, LabelWrapper, InputWrapper, InputWrapperGraded } from './styles';
import { Rules } from "../Rules/Rules";
import { changeAddress,updateContributionStatus, updateErrorMessage } from "../../../actions";

class InputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {currentValue: this.props.value}
    }

    componentWillReceiveProps(nextProps){
        if(this.props.donorId && (this.props.assetHeld === nextProps.showErrorMessage.assetHeld) && nextProps.showErrorMessage.inputComponent){
            let id = this.props.assetHeld + this.props.contributionType + this.props.accountId.toString() + this.props.donorId.toString() + this.props.key + this.props.property;
            let value = {};
            value[id] =  this.props.value;
            this.props.form.setFieldsValue(value);
          this.props.form.validateFields();
          let lastComp = false;
          if(this.props.assetHeld === 'assetHeldatVG' && this.props.contributionType === 'mutualFund'){
            if(this.props.property === 'taxIdNumber'){
                lastComp = true;
            }
          }else if(this.props.property === 'lastName' || this.props.property === 'name'){
            lastComp = true;
          }
          if((this.props.accountId) === this.props.giftLength && lastComp){
            if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected))
            this.props.updateErrorMessages({type: 'inputComponent'});
          }
          if((this.props.accountId + 1) === this.props.giftLength && lastComp){
            if(this.props.accountInfo[this.props.accountId + 1]['type'] === 'Select Account Type'){
              if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected))
              this.props.updateErrorMessages({type: 'inputComponent'});
            }
          }
      }
     }

    onTextChange= (e,regex) => {
      let updatedValue = e.target.value.replace(/\s{2,}/g, ' ').replace('. ','');
      if(updatedValue.length === 1){
        updatedValue = updatedValue.replace(/\s{1,}/g, '');
      }
        if(regex.test(updatedValue)){
          if(this.props.donorId > 0){
              (e.target.value !== this.state.currentValue) && this.setState({currentValue:updatedValue });
          };
        this.props.updateContributionStatus();
        }
    }

    onBlur = (e) => {
      e.target.value !== this.props.value && this.props.updateValue(e.target.value);
    }

    nameRules = {"rules": [
        {
          required: true,
          message: <ErrorMesage>Please enter {this.props.label.toLowerCase()}.</ErrorMesage>
        },
        {
          min: 2,
          message: <ErrorMesage> {this.props.errorLabel ? this.props.errorLabel : this.props.label} is too short. Please correct to continue.</ErrorMesage>
        },
        {
          max: 100,
          message: <ErrorMesage> Maximum character limit for {this.props.label.toLowerCase()} is 100. Please correct to Proceed </ErrorMesage>
        }
      ]
    };

    taxIdRules = {rules:[
        {
          required: true,
          message: <ErrorMesage>Please enter the {this.props.donorName.toLowerCase()}'s nine-digit tax ID number.</ErrorMesage>
        },
        {
          pattern: /^([0-9]{9}|([0-9]{2}[-]{1}[0-9]{7})|([0-9]{3}[-]{1}[0-9]{2}[-]{1}[0-9]{4}))$/,
          message: <ErrorMesage>Tax ID number should be in one of two formats xx-xxxxxxx or xxx-xx-xxxx. Please correct to continue.</ErrorMesage>
        }
      ], onchangePattern:/^[0-9-]{0,11}$/ }

    render() {
        const { getFieldDecorator } = this.props.form;
        let placeHolder = "Enter " + this.props.label.toLowerCase();
        const inputId = this.props.assetHeld + this.props.contributionType + this.props.accountId.toString() + this.props.donorId.toString() + this.props.key + this.props.property + 'id';
        const currentValue = this.state.currentValue;
        return (
            <WrapLabel>
                <InputWrapper>
                    <Form.Item
                        colon={false}
                        label={<LabelWrapper>{this.props.label}</LabelWrapper>}>
                        {getFieldDecorator( this.props.assetHeld + this.props.contributionType + this.props.accountId.toString() + this.props.donorId.toString() + this.props.key + this.props.property, {
                            validateTrigger: "onBlur",
                            rules: ( this.props.property === "name" ? this.nameRules.rules : (this.props.property === "taxIdNumber" ? this.taxIdRules.rules : ([this.props.property] ? Rules[this.props.property].rules:""))),
                        })(
                            (this.props.donorId === 0) ?
                            <InputWrapperGraded>
                                <InputWrapper>
                                <div id={inputId}>
                                    <InputField placeholder={placeHolder} className="macInputFieldPadding" aria-labelledby={this.props.property} role="textbox" disabled value={this.props.loggedInValue} getPopupContainer={() => document.getElementById(inputId)} />
                                </div>
                                </InputWrapper>
                            </InputWrapperGraded>
                            :
                            <InputWrapper>
                                <InputField placeholder={placeHolder} className="macInputFieldPadding" aria-labelledby={this.props.property} role="textbox" value={currentValue} onBlur={this.onBlur}  onChange={e =>this.onTextChange(e, Rules[this.props.property]?Rules[this.props.property].onchangePattern:/^.*$/)} />
                            </InputWrapper>

                        )}
                    </Form.Item>
                </InputWrapper>
            </WrapLabel>
        )
    }

}

const WrappedInputComponent = Form.create({ name: "select" })(InputComponent);

WrappedInputComponent.propTypes = {
  value: PropTypes.string,
  donorName: PropTypes.string,
  isDummyUpdated: PropTypes.bool,
  showErrorMessage: PropTypes.object,
  accountInfo: PropTypes.string,
  isSecuritySelected: PropTypes.bool,
  loggedInValue: PropTypes.string,


  updateValue: PropTypes.func,
  updateContributionStatus: PropTypes.func,
  updateErrorMessages: PropTypes.func,

}

const mapStateToProps = (state,ownProps) => ({
    value: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,`${ownProps.contributionType}`,`${ownProps.accountId}`,"Donors",`${ownProps.donorId}`,`${ownProps.property}`]),
    donorName: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,`${ownProps.contributionType}`,`${ownProps.accountId}`,'type']),
    isDummyUpdated: state.getIn(["makeAContribution", "contributionTypes", "dummyUpdate"]),
    showErrorMessage: state.getIn(["makeAContribution","contributionTypes",'showErrorMessage']),
    accountInfo: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`, `${ownProps.contributionType}`]),
    isSecuritySelected: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,'sgSelected']),
    loggedInValue: state.getIn(['makeAContribution','apiData', 'loggedInAddress','data',`${ownProps.property}`])
})

export const mapDispatchToProps = (dispatch,ownProps) => ({
    updateValue: e=> dispatch(changeAddress({value: e, accountId : ownProps.accountId, contributionType: ownProps.contributionType, assetHeld: ownProps.assetHeld, donorId: ownProps.donorId, property: ownProps.property })),
    updateContributionStatus: () => dispatch(updateContributionStatus({value:false,assetHeld: ownProps.assetHeld})),
    updateErrorMessages: data => dispatch(updateErrorMessage(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedInputComponent));
